export default __webpack_public_path__ + "logo.png?8975c4e69687076fdeb518ce1712e465";